export default class ApiKeyService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllApiKeys() {
    return this.axiosIns.get(`${this.serviceConfig.apiKeyEndpoint}`);
  }

  createApiKey(args) {
    return this.axiosIns.post(`${this.serviceConfig.apiKeyEndpoint}`, args);
  }

  updateApiKey(id, args) {
    return this.axiosIns.put(`${this.serviceConfig.apiKeyEndpoint}/${id}`, args);
  }

  deleteApiKey(id) {
    return this.axiosIns.delete(`${this.serviceConfig.apiKeyEndpoint}/${id}`);
  }
}
